import { API_BASE_URL } from "../../../config";

const normalizeBalance = (value) => {
  if (value == null) return 0;
  const parsed = parseFloat(typeof value === "string" ? value.replace(",", ".") : value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const fetchBillingEntries = async ({ authToken, filters }) => {
  const searchParams = new URLSearchParams(
    Object.entries(filters)
      .filter(([, val]) => Boolean(val))
      .reduce((acc, [key, val]) => ({ ...acc, [key]: val }), {}),
  );

  const response = await fetch(`${API_BASE_URL}/api/billing/?${searchParams.toString()}`, {
    headers: { Authorization: `Token ${authToken}` },
  });

  if (!response.ok) {
    let message = `HTTP ${response.status}`;
    try {
      const payload = await response.json();
      message = payload.detail || payload.error || payload.message || message;
    } catch {
      /* ignore */
    }
    if (
      response.status === 400 ||
      response.status === 401 ||
      /no Allegro token|authorization required/i.test(message)
    ) {
      message = "No connection with Allegro. Connect first to view billing entries.";
    }
    throw new Error(message);
  }

  const data = await response.json();
  const rows = data.results || data.items || (Array.isArray(data) ? data : []);
  const count = Number(data.count ?? (Array.isArray(rows) ? rows.length : 0));
  const balance = normalizeBalance(data.currentBalance ?? 0);

  return {
    rows,
    count: Number.isFinite(count) ? count : 0,
    balance,
  };
};
